import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import AddingButton from './AddingButton';
import ProjectTagModal from './ProjectTagModal';

const ProjectTag = ({ tags, setTags, selectedTags, setSelectedTag }) => {
  const [isProjectTagModalVisible, setIsProjectTagModalVisible] = useState(false);

  const getExistedTag = useCallback(
    tag => {
      const existedTag = selectedTags.find(projectTag => projectTag === tag);

      return existedTag;
    },
    [tags, selectedTags],
  );

  // const handleProjectTagClick = useCallback(
  //   tag => {
  //     const existedTag = getExistedTag(tag);

  //     if (existedTag) {
  //       const filteredProjectTagList = tags.filter(projectTag => projectTag !== tag);

  //       setTags(filteredProjectTagList);
  //     } else {
  //       setTags([...tags, tag]);
  //     }
  //   },
  //   [tags],
  // );

  const handleProjectTagClick = useCallback(
    tag => {
      const existedTag = getExistedTag(tag);
      if (existedTag) {
        const filteredProjectTagList = selectedTags.filter(projectTag => projectTag !== tag);
        setSelectedTag(filteredProjectTagList);
      } else {
        setSelectedTag([...selectedTags, tag]);
      }
    },
    [tags, selectedTags],
  );

  const handleProjectTagModalVisible = useCallback(() => {
    setIsProjectTagModalVisible(!isProjectTagModalVisible);
    setTags([...selectedTags]);
  }, [isProjectTagModalVisible, selectedTags]);

  const handleProjectTagCreateCancelClick = () => {
    setIsProjectTagModalVisible(!isProjectTagModalVisible);
    setSelectedTag([...tags]);
  };

  return (
    <>
      <AddingButton
        isProjectTagModalVisible={isProjectTagModalVisible}
        tags={tags}
        handleProjectTagModalVisible={handleProjectTagModalVisible}
      />
      <ProjectTagModal
        isProjectTagModalVisible={isProjectTagModalVisible}
        getExistedTag={getExistedTag}
        handleProjectTagClick={handleProjectTagClick}
        handleProjectTagModalVisible={handleProjectTagModalVisible}
        handleProjectTagCreateCancelClick={handleProjectTagCreateCancelClick}
      />
    </>
  );
};

ProjectTag.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  setTags: PropTypes.func.isRequired,
};

export default ProjectTag;
